module.exports = __webpack_public_path__ + "img/5.853ac0a6.png";